<template>
  <avl-modal
    class="m-roles"
    :is-shown="!!getRoles.length"
    :is-toggled-initial="false"
    is-collapsible
    is-left-aligned
    notch-text-when-hidden="Roles"
  >
    <div class="m-roles__inner">
      <div class="m-roles__roles-container">
        <h1 class="m-roles__title">Roles in the game</h1>

        <ul class="m-roles__roles" v-for="team in [getServants, getMinions]">
          <li class="m-roles__role" v-for="role in team" :key="role.id">
            <button
              class="m-roles__avatar-button"
              type="button"
              :class="{
                'm-roles__avatar-button--selected': role === selectedRole,
              }"
              @click="selectRole(role)"
            >
              <avl-player-avatar class="m-roles__player-avatar" :id="role.id" :team="role.team" />
            </button>
          </li>
        </ul>
      </div>

      <div class="m-roles__selected-role" v-if="selectedRole">
        <div class="m-roles__player-avatar-wrapper">
          <avl-player-avatar
            class="m-roles__player-avatar"
            :id="selectedRole.id"
            :team="selectedRole.team"
          />
        </div>

        <h2 class="m-roles__sub-title">{{ selectedRole.title }}</h2>

        <p class="m-roles__description">{{ selectedRole.description }}</p>
      </div>
    </div>
  </avl-modal>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({
      isShown: false,
      selectedRole: null,
    }),
    computed: {
      ...mapGetters(['getRoles']),
      getServants() {
        return this.getRoles.filter(({ team }) => team === 'SERVANTS');
      },
      getMinions() {
        return this.getRoles.filter(({ team }) => team === 'MINIONS');
      },
    },
    methods: {
      selectRole(role) {
        this.selectedRole = this.selectedRole === role ? null : role;
      },
    },
  };
</script>

<style lang="scss">
  .m-roles {
    .modal {
      height: 470px;
    }

    &__inner {
      display: flex;
      height: 100%;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
    }

    &__title {
      margin: 0;
      text-transform: capitalize;
    }

    &__roles {
      padding: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-evenly;
    }

    &__role {
      width: 58px;
      height: 58px;
    }

    &__avatar-button {
      width: 100%;
      height: 100%;
      padding: 0;
      border: none;
      background: none;
      transition: filter 200ms, transform 200ms;
      filter: grayscale(0.8);

      &:focus,
      &:hover,
      &--selected {
        filter: none;
        transform: scale(1.08);
      }
    }

    &__selected-role {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__player-avatar-wrapper {
      width: 120px;
      height: 120px;
    }

    &__player-avatar {
      width: 100%;
      height: 100%;
    }

    &__sub-title {
      margin: 0;
    }

    &__description {
      margin-bottom: 0;
    }
  }
</style>
